module.exports = __webpack_public_path__ + "static/media/09.e812124b.wav";